var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"border border-secondary",attrs:{"title":"Reaktife Giren Cihazlar"}},[_c('b-table-lite',{staticClass:"yeni",attrs:{"hover":"","items":_vm.items}}),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }